import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  DefaultButton,
  DefaultPrimaryButton,
  InputWithLabel,
} from "../../../../components/micro/input";
import Breadcrumb from "../../../../components/common/BreadCrumb";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { createCompany } from "../../../../redux/companies/slice";

const CreateCompany = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    const payload = {
      name: values.companyName,
      uen: values.companyUEN,
      address: values.address,
      postal_code: values.postalcode,
      remarks: values.remarks,
    };

    try {
      const res = await dispatch(createCompany(payload));
      if (res.type === "createCompany/fulfilled") {
        const companyData = res?.payload?.data;
        sessionStorage.setItem(
          "companyData",
          JSON.stringify({ company: companyData })
        );
        navigate("/company-information", {
          state: { company: companyData },
        });
      }
    } catch (error) {
      console.error("Error creating company:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="mb-5">
        <h6 className="font-Montserrat font-medium text-xl mb-3">
          Company & Outlets
        </h6>
        <Breadcrumb
          breadCrumbParent={"Home"}
          breadCrumbActive={"Create Company"}
          breadCrumbParent2={"Company & Outlets"}
          breadCrumbTitleKey={"/"}
          classes=""
        />
        <div className="pt-5">
          <h1 className="text-2xl font-normal text-mgrey font-Montserrat">
            Create New Company
          </h1>
        </div>
      </div>
      <Formik
        enableReinitialize={true}
        initialValues={{
          companyName: "",
          companyUEN: "",
          address: "",
          postalcode: "",
          remarks: "",
        }}
        validationSchema={Yup.object().shape({
          companyName: Yup.string().min(3).required("Please enter name"),
          address: Yup.string().min(3).required("Please enter address"),
          postalcode: Yup.string()
            .required("Please enter postal code")
            .length(6, "Postal code must be exactly 6 digit")
            .matches(/^\d+$/, "Postal code must be numeric"),
        })}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <div className="w-full bg-bgWhite shadow drop-shadow-md rounded-lg py-5 px-6">
              <div>
                <h2 className="text-xs pb-4 font-normal text-mgrey">
                  Basic Information
                </h2>
              </div>
              <div className="grid grid-cols-2 gap-6 mb-4">
                {/* Name */}
                <InputWithLabel
                  className={` ${
                    errors.companyName && touched.companyName
                      ? `border border-red`
                      : `border border-borderTheme/80 focus-within:border-themeBtn `
                  } transition duration-300 ease-in-out`}
                  idFromName="companyName"
                  label="Company Name*"
                  type="text"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.companyName}
                  errors={errors.companyName && touched.companyName}
                  errorsText={errors.companyName}
                />
                {/* company UEN */}
                <InputWithLabel
                  className={` ${
                    errors.companyUEN && touched.companyUEN
                      ? `border border-red`
                      : `border border-borderTheme/80 focus-within:border-themeBtn `
                  } transition duration-300 ease-in-out`}
                  idFromName="companyUEN"
                  label="Company UEN"
                  type="number"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.companyUEN}
                  onFocus={(e) =>
                    e.target.addEventListener(
                      "wheel",
                      function (e) {
                        e.preventDefault();
                      },
                      { passive: false }
                    )
                  }
                />
                {/* Address */}
                <InputWithLabel
                  className={` ${
                    errors.address && touched.address
                      ? `border border-red`
                      : `border border-borderTheme/80 focus-within:border-themeBtn `
                  } transition duration-300 ease-in-out`}
                  idFromName="address"
                  label="Address*"
                  type="text"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.address}
                  errors={errors.address && touched.address}
                  errorsText={errors.address}
                />
                {/* Postal Code */}
                <InputWithLabel
                  className={` ${
                    errors.postalcode && touched.postalcode
                      ? `border border-red`
                      : `border border-borderTheme/80 focus-within:border-themeBtn `
                  } transition duration-300 ease-in-out`}
                  idFromName="postalcode"
                  label="Postal Code*"
                  type="number"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.postalcode}
                  errors={errors.postalcode && touched.postalcode}
                  errorsText={errors.postalcode}
                  onFocus={(e) =>
                    e.target.addEventListener(
                      "wheel",
                      function (e) {
                        e.preventDefault();
                      },
                      { passive: false }
                    )
                  }
                />
              </div>
            </div>
            <div className="w-full bg-bgWhite shadow drop-shadow-md rounded-lg py-5 px-6 mt-4">
              <div>
                <h2 className="text-xs pb-4 font-normal text-mgrey">Remarks</h2>
              </div>
              <div>
                <InputWithLabel
                  className={` ${
                    errors.remarks && touched.remarks
                      ? `border border-red`
                      : `border border-borderTheme/80 focus-within:border-themeBtn `
                  } transition duration-300 ease-in-out`}
                  idFromName="remarks"
                  label="Remark’s Description"
                  type="text"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.remarks}
                />
              </div>
            </div>
            {/* Submit button */}
            <div className="flex justify-end gap-3 mt-3">
              <DefaultPrimaryButton
                type="button"
                value="Cancel"
                onClick={() => navigate(-1)}
              />
              <DefaultButton type="submit" value="Create" />
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CreateCompany;
